import React, { useState, useEffect } from "react";
import GoogleMapReact from 'google-map-react';
import { geocodeByAddress, getLatLng } from 'react-places-autocomplete';
import { LoadingIcon, Button } from '@prosolve/common-components-ui'
import { FaMapMarkerAlt, FaLocationArrow } from "react-icons/fa";
import useIsMobileView from "../../../../hooks/useIsMobileView";
import { getClientSubdomain } from '../../../../utils'

export default ({
  eventData = {}
}) => {
  const clientSubdomain = getClientSubdomain()
  const isStarSubdomain = (clientSubdomain === 'star')
  const isMobileView = useIsMobileView();

  const {
    addressStreet = '',
    addressCity = '',
    addressState = '',
    addressZip = '',
    additionalLocationNotes = ''
  } = eventData

  // Mark has address to true if we have any of the 4 parts
  const hasAddress = Boolean(addressStreet || addressCity || addressState || addressZip);

  const [isLoading, setIsLoading] = useState(true)
  const [geoLocation, setGeoLocation] = useState();

  const getLocationCoords = async (address) => {
    setIsLoading(true)
    try {
      const results = await geocodeByAddress(address);
      const latLngResults = await getLatLng(results[0]);
      const { lat, lng } = latLngResults;
      const centerState = {
        center: {
          lat: lat,
          lng: lng,
        },
        zoom: 11,
      };

      setGeoLocation(centerState);

    } catch(e) {
      console.error('Error', e)
      setGeoLocation(undefined)
    }
    setIsLoading(false)
  }
  
  useEffect(() => {
    const fullAddress = `${addressStreet}, ${addressCity}, ${addressState} ${addressZip}`
    getLocationCoords(fullAddress)
  }, [addressStreet, addressCity, addressState , addressZip])

  const onClickMapItButton = () => {
    window.open(`https://www.google.com/maps/search/?api=1&query=${geoLocation.center.lat},${geoLocation.center.lng}`,'_blank');
  }

  const renderMarkers = (map, maps) => {
    let marker = new maps.Marker({
      position: { lat: geoLocation.center.lat, lng: geoLocation.center.lng },
      map,
      title: 'Google Location',
    });
    return marker;
  };

  return (
    <div
      style={{
        padding: '20px'
      }}
    >
      <div style={{
        color: '#565656',
        fontSize: '24px',
        fontWeight: 'bold',
        marginBottom: '20px'
      }}>
        Event Location
      </div>
      { hasAddress ?
        <div style={{ display: 'flex', flexDirection: isMobileView ? 'column' : 'row', rowGap: '20px' }}>
          <div 
            style={{ 
              flex: isMobileView ? 'none' : 1, 
              width: isMobileView ? '100%' : 'auto',
              height: '300px',
              paddingRight: '20px'
            }}
          >
            {
              Boolean(geoLocation) ?
              <GoogleMapReact
                bootstrapURLKeys={{
                  key: 'AIzaSyAkV7-irkPHctxGu878V9YelJ-N9sIZhHA',
                }}
                center={geoLocation.center}
                defaultZoom={geoLocation.zoom}
                yesIWantToUseGoogleMapApiInternals={true}
                onGoogleApiLoaded={({ map, maps }) => renderMarkers(map, maps)}
              >
              </GoogleMapReact>
            : 
            <div style={{
              width: '100%',
              height: '100%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              border: '1px solid #dedede',
              borderRadius: '5px',
              background: '#fdfdfd',
            }}>
              {isLoading ? <LoadingIcon /> : 'Unable to find address location'}
            </div>
            }
          </div>
          <div style={{ flex: 1 }}>
            {
              hasAddress &&
              <div style={{
                display: 'flex',
                border: '1px solid #dedede',
                borderRadius: '5px',
                background: '#fdfdfd',
                padding: '20px'
              }}>
                <FaMapMarkerAlt style={{ fontSize: '22px', color: '#C2C9D1', marginRight: '10px' }} />
                <div style={{
                  display: 'flex',
                  flexDirection: 'column',
                  color: '#565656',
                }}>
                  <div style={{ marginTop: '1px', fontWeight: 'bold' }}>{addressStreet || ''}</div>
                  <div style={{ marginTop: '5px' }}>{`${addressCity || ''}, ${addressState || ''} ${addressZip || ''}`}</div>
                  <div style={{ marginTop: '20px' }}>
                    <Button
                      style={{
                        display: 'inline-flex',
                        padding: '8px 16px'
                      }}
                      onClick={onClickMapItButton}
                    >
                      <FaLocationArrow style={{ marginRight: '10px', color: '#0280c6' }} />
                      <span style={{ fontWeight: 'bold', color: '#565656'}}>{'Map It'}</span>
                    </Button>
                  </div>
                </div>
              </div>
            }
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              color: '#565656',
              border: '1px solid #dedede',
              borderRadius: '5px',
              background: '#fdfdfd',
              padding: '20px',
              marginTop: '20px'
            }}>
              <div style={{ fontWeight: 'bold' }}>{'Additional Location Notes'}</div>
              {Boolean(additionalLocationNotes) 
                ? <div style={{ marginTop: '10px' }}>{additionalLocationNotes}</div>
                : <div style={{ marginTop: '10px' }}>No additional location notes provided</div>
              }
            </div>
          </div>
        </div>
        :
        <div style={{
          display: 'flex',
          border: '1px solid #dedede',
          borderRadius: '5px',
          background: '#fdfdfd',
          padding: '20px'
        }}>
          {isStarSubdomain ? 'Check back a week before the event to see this info.' : 'No address found for this event.'}
        </div>
      }
    </div>
  )
}